import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import "./Dialog.css";
const MyDialog = (props) => {
  const [Transition, setTransition] = useState();
  useEffect(() => {
    setTransition(
      React.forwardRef(function Transition(props, ref) {
        return <Slide direction={"up"} ref={ref} {...props} />;
      })
    );
  }, [props.open]);

  let dialog = (
    <Dialog
      className={"Dialog"}
      open={props.open}
      onClose={props.onClose}
      fullScreen={props.fullScreen}
      scroll={props.scroll}
    >
      <DialogContent>{props.children}</DialogContent>
    </Dialog>
  );
  if (props.direction) {
    dialog = (
      <Dialog
        className={"Dialog"}
        TransitionComponent={Transition}
        open={props.open}
        onClose={props.onClose}
        fullScreen={props.fullScreen}
        scroll={props.scroll}
      >
        <DialogContent>{props.children}</DialogContent>
      </Dialog>
    );
  }
  return props.open ? dialog : null;
};
export default MyDialog;
